import React, { useMemo, useState } from "react";
import { BsCaretDownFill, BsCaretRightFill, BsPeople, BsGenderMale, BsGenderFemale, BsGrid, BsLightning } from "react-icons/bs";

const PrescriptionKPI = ({ doctors = [], isLoading = false, showKPIs = true }) => {
    const [showKPI, setShowKPI] = useState(showKPIs);

    // Calculate all KPIs based on filtered doctors received as props
    const kpis = useMemo(() => {
        // No data case
        if (!doctors || doctors.length === 0) {
            return {
                totalDoctors: 0,
                totalMales: 0,
                totalFemales: 0,
                uniqueSpecialties: 0,
                totalActive: 0
            };
        }

        const totalDoctors = doctors.length;
        const totalMales = doctors.filter(d => d.gender?.toLowerCase() === 'male').length;
        const totalFemales = doctors.filter(d => d.gender?.toLowerCase() === 'female').length;
        const allServices = doctors.flatMap(d => Array.isArray(d.services) ? d.services : []);
        const uniqueSpecialties = new Set(allServices).size;
        const totalActive = doctors.filter(d => d.isActive).length;

        return {
            totalDoctors,
            totalMales,
            totalFemales,
            uniqueSpecialties,
            totalActive
        };
    }, [doctors]);

    // Format numbers with commas for thousands
    const formatNumber = (value) => {
        if (typeof value === 'number') {
            return value.toLocaleString();
        }
        return value;
    };

    const toggleKPI = () => setShowKPI(prev => !prev);

    // Define KPI cards data with consistent styling
    const kpiCards = [
        { 
            title: 'Total Doctors', 
            value: kpis.totalDoctors,
            icon: <BsPeople />, 
            iconColor: '#f5f2e8'
        },
        { 
            title: 'Males', 
            value: kpis.totalMales,
            icon: <BsGenderMale />, 
            iconColor: '#e8f4fd'
        },
        { 
            title: 'Females', 
            value: kpis.totalFemales,
            icon: <BsGenderFemale />, 
            iconColor: '#fde8f4'
        },
        { 
            title: 'Specialties', 
            value: kpis.uniqueSpecialties,
            icon: <BsGrid />, 
            iconColor: '#e8f5e8'
        },
        { 
            title: 'Active', 
            value: kpis.totalActive,
            icon: <BsLightning />, 
            iconColor: '#f0e8fd'
        }
    ];

    if (isLoading) {
        return <div>Loading indicators...</div>;
    }

    return (
        <>   
            {showKPI && (
                <div className="row gy-3 introbx_row">
                    {kpiCards.map((kpi, index) => (
                        <div key={index} className="col">
                            <div className="d-flex align-items-center gap-2 p-3 rounded-10 shadow-sm">
                                <div className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '2rem', height: '2rem', backgroundColor: '#E4E4FF', color: '#8381FF' }}>
                                    <span className="d-block material-symbols-outlined fs-lg">{kpi.icon}</span>
                                </div>
                                <div className="info flex-fill">
                                    <p className="fs-sm text-gray mb-0">{kpi.title}</p>
                                    <p className="lh-1 fw-semibold">{formatNumber(kpi.value)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default PrescriptionKPI;